import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const LinkIcon = (props: SvgProps) => <Svg
  width='20'
  height='20'
  viewBox='0 0 20 20'
  fill='none'
  {...props}
>
  <Path
    d='M15.8333 8.33464L15.8326 4.16862L11.6666 4.16797M11.6666 8.33464L15.8333 4.16797M14.1666 11.1124V15.2791C14.1666 15.4264 14.1081 15.5677 14.0039 15.6719C13.8997 15.7761 13.7584 15.8346 13.6111 15.8346H4.72218C4.57484 15.8346 4.43353 15.7761 4.32934 15.6719C4.22516 15.5677 4.16663 15.4264 4.16663 15.2791V6.39019C4.16663 6.24285 4.22516 6.10154 4.32934 5.99735C4.43353 5.89317 4.57484 5.83464 4.72218 5.83464H8.88885'
    stroke='#3379BD'
    strokeWidth='1.5'
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default LinkIcon;
